export default "__VITE_ASSET__CCGFyByg__"